import AnswerCard from '@jdh-cargo/block-content-answer-card';
// import AnswerCard from './dist';
import BreadCrumb from '../BreadCrumb';
import { setHospitalTDK } from 'utils/hospital';
import { Template } from '../template';
import { useParams } from 'react-router-dom';

export default () => {
  setHospitalTDK('京东健康问答 - 京东健康互联网医院', '京东健康问答', '京东健康问答');
  const params = useParams<any>(); // 这个 jdh-cargo 库的组件如果使用了useParams打包后获取不到真实的参数，因此需要外边传进去
  
  return (
    <Template>
      <BreadCrumb title="健康问答"></BreadCrumb>
      {/* @ts-ignore */}
      <AnswerCard moreUrl="answerList" paging={true} hideWhenAnswerListNone={true} urlParams={params}/>
    </Template>
  );
};
